// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"27f4851b","391":"4c7fd1ff","448":"afbc6c7d","503":"5360f0b5","560":"57e9d22a","668":"8997da51"}[chunkId] + ".chunk.css";
};